export enum EBadgeColor {
	darkred,
	saddlebrown,
	green
}
